<style lang="scss">
  div {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    display: inline-table;
  }

  .u--larger {
    width: 88px;
    height: 88px;
  }
</style>

<script>
  export let avatar;
  export let larger = false;
</script>

<div class:u--larger={larger} style={`background-image: url(${avatar ||
'https://events.thehoneycombproject.org/static/avatar.png'})`}/>
